import { axiosDelete } from '@/api/handlers';
import { useMutation } from '@/api/hooks';
import { useRemoveQueries } from '@/hooks';
import { useCookies } from 'react-cookie';

export const useLogout = () => {
  const { removeQueries } = useRemoveQueries();
  const [, , removeCookie] = useCookies();
  return useMutation({
    mutationFn: async () => {
      const res = await axiosDelete('/api/logout/');
      removeQueries();
      return res;
    },
    onSuccess: () => {
      removeCookie('access_token');
      removeCookie('csrftoken');
    },
  });
};
